import {useSearchParams} from 'react-router-dom';
import {useEffect} from 'react';
import {fromSearchParams, toQueryString, toSearchParams} from '../../Support/query';

export function useObserveSearchParams<T>(
    input: T,
    callback: (output: Partial<T>) => void,
    serialise: (input: T) => object | null = (i: T): object => i as object,
    deserialise: (serialised: object | null) => T = (serialised: object | null): T => serialised as T,
): void {
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        const current = deserialise(fromSearchParams(searchParams));
        if (toQueryString(input) !== toQueryString(current)) {
            setSearchParams(toSearchParams(serialise(input)));
        }
    }, [input]);
    useEffect(() => {
        callback(deserialise(fromSearchParams(searchParams)) as Partial<T>);
    }, [searchParams]);
}
